module.exports = createBulkSnapshots
const createSnapshot = require('./shipment-create-snapshot')

function createBulkSnapshots (state, params) {
  const promises = params.map(param => createSnapshot(state, param))
  return Promise.all(promises)
}
